import { useMutation } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'

export function useFinalizePublicWitness() {
  return useMutation({
    mutationFn: async ({ id_client, slot, cpf, assinatura }: { id_client: string; slot: 1 | 2; cpf: string; assinatura: File }) => {
      const formData = new FormData()
      formData.append('signature', assinatura)
      formData.append('cpf', cpf)

      const response = await publicApi.post(`/signatures/public/${id_client}/witness/${slot}/signature`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })

      if (!response.data) throw new Error('Erro ao concluir assinatura da testemunha')
      return response.data
    }
  })
}
